export default {
  type: 'object',
  properties: {
    title: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'Opis',
      type: 'string',
      fieldRequired: false
    },
    html: {
      title: 'Dokument',
      type: 'string'
    },
    htmls: {
      type: 'array',
      items: {
        title: 'Dokument',
        type: 'string'
      }
    }
  }
};
